export const USER_ROLES = {
  FARMER: "farmer",
  AGRONOMIST: "agronomist",
  KYD: "kydUser",
};

// Role codenames scoped under a team/legal entity (as opposed to
// global roles like farmer/agronomist) — only these show the
// "verified" checkmark in the navbar's role switcher.
export const TEAM_SCOPED_ROLE_CODENAMES = ["le_admin", "le_employee"];

export const USER_DOMAINS = {
  PRIVATE: "private_camvio",
  PUBLIC: "public_camvio",
};

export const ROLE_BASED_PERMISSIONS = {
  SCREENS: {
    LE_DASHBOARD_SCREEN: "canViewLeDashboardScreen",
    AGRONOMIST_DASHBOARD_SCREEN: "canViewAgronomistDashboardScreen",
    FIELDS_SCREEN: "canViewFieldsScreen",
    FARMERS_SCREEN: "canViewFarmersScreen",
    AGRONOMISTS_SCREEN: "canViewAgronomistsScreen",
    COLLABORATION_SCREEN: "canViewCollaborationScreen",
    EQUIPMENTS_SCREEN: "canViewEquipmentsScreen",
    NEWS_SCREEN: "canViewNewsScreen",
    INSTRUCTIONS_SCREEN: "canViewInstructionsScreen",
    NOTIFICATIONS_SCREEN: "canViewNotificationsScreen",
    PROFILE_SCREEN: "canViewProfileScreen",
    OPEKEPE_SCREEN: "canViewOpekepeScreen",
    MESSAGES_SCREEN: "canViewMessagesScreen",
    SPD_INVOICES_SCREEN: "canViewSpdInvoicesScreen",
  },
  WIDGETS: {
    MANAGE_MY_AGRONOMIST_PREFERENCES: "canManageMyAgronomistPreferences",
  },
};

export const PLAN_BASED_PERMISSIONS = {
  ANNA_BOT_WIDGET: "canUseAnnaOsdeAssistant",
};
